import { post } from "@/api/http";


export default {
    getCardCollectSas: function () {
        return post("/cardcollect/sas");
    },
    createCardCollect: function (data) {
        return post("/cardcollect/create-cardcollect", data);
    },
    updateCardCollect: function (data) {
        return post("/cardcollect/update-cardcollect", data);
    },
    getCardCollectById: function (data) {
        return post("/cardcollect/get-my-cardcollects", data);
    },
    getCardCollect: function (data) {
        return post("/cardcollect/get-cardcollect", data);
    },
    deleteCardCollect: function (data) {
        return post("/cardcollect/delete-cardcollect", data);
    },

    // Card 相關 API 方法
    createCard: function (data) {
        return post("/card/create-card", data);
    },
    updateCard: function (data) {
        return post("/card/update-card", data);
    },
    getCardsByCollect: function (data) {
        return post("/card/get-cards-by-collect", data);
    },
    deleteCard: function (data) {
        return post("/card/delete-card", data);
    },
    searchCards: function (data) {
        return post("/card/search-cards", data);
    },
    
    // Blob 檔案管理相關 API
    deleteCardFiles: function (data) {
        return post("/cardcollect/delete-file", data);
    },
    deleteCollectFiles: function (data) {
        return post("/cardcollect/delete-collect-files", data);
    },

    // Comment 相關 API 方法
    createComment: function (data) {
        return post("/CardComment/create-comment", data);
    },
    updateComment: function (data) {
        return post("/CardComment/update-comment", data);
    },
    deleteComment: function (data) {
        return post("/CardComment/delete-comment", data);
    },
}
